// extracted by mini-css-extract-plugin
module.exports = {"signupButton":"_1ZS9MvY6UDWHyoFcC-Q1cN"};